export const splineKind = {
  CARDINAL_SPLINE: 'CARDINAL_SPLINE',
  KOCHANEK_SPLINE: 'KOCHANEK_SPLINE',
};

export default {
  splineKind,
};
